import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=fda6c222&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=fda6c222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda6c222",
  null
  
)

component.options.__file = "ProductList.vue"
export default component.exports